import { Navigate, useLocation } from "react-router-dom";
import Pages from "pages/pages";

function Component() {
  const location = useLocation();
  if (!location.pathname.startsWith("/pages")) {
    return <Navigate to="/pages" replace />;
  }
  return <Pages />;
}

export default Component;
